export const TRACKING_CODES = {
  api_terms_link_clicked: 'api-terms-link-clicked',
  connected_partners_link_clicked: 'connected-partners-link-clicked',
  contact_us_link_clicked: 'contact-us-link-clicked',
  talent_contact_us_link_clicked: 'talent-contact-us-link-clicked',
  talent_help_center_link_clicked: 'talent-help-center-link-clicked',
  privacy_link_clicked: 'privacy-link-clicked',
};
